// Auto-generated from image.spec.js
export default {
  "tagName": "ui-image",
  "content": [
    "src",
    "lightSrc",
    "darkSrc"
  ],
  "contentAttributes": [
    "src",
    "lightSrc",
    "darkSrc"
  ],
  "attributes": [
    "src",
    "lightSrc",
    "darkSrc"
  ],
  "propertyTypes": {
    "src": "string",
    "lightSrc": "string",
    "darkSrc": "string"
  }
};
